<template>
  <v-card class="mt-6">
    <v-card-text>
      <v-container>
        <v-row class="align-center justify-center">
          <v-col cols="12" md="7">
            <div class="d-flex align-center">
              <v-img
                width="65"
                class="ma-0"
                :src="moneyShieldIcon"
                alt="moneyshield-icon"
                role="presentation"
              />
              <h4 role="heading" aria-level="3" class="ml-6">
                <span class="text-h4 d-block font-weight-bold">{{
                  $t('L_are_you_protected')
                }}</span>
                <span
                  class="d-block font-weight-regular"
                  v-html="$t('L_when_life_changes_your_financial')"
                ></span>
              </h4>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="5"
            class="d-flex"
            :class="$vuetify.display.mdAndUp ? 'justify-end' : 'justify-center'"
            v-if="showGuidanceCalculatorTab"
          >
            <OnexButton
              variant="outlined"
              color="primary"
              width="320"
              @click="navigateToGuidanceCalculator"
            >
              {{ $t('L_get_guidance') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import moneyShieldIcon from '../assets/money-shield-icon.svg';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { RouteNames } from '@/router/routeNames';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'AreYouProperlyProtectedCard',
  components: {
    OnexButton,
  },
  props: {
    indexPolicy: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return { moneyShieldIcon };
  },
  computed: {
    showGuidanceCalculatorTab() {
      return !CapacitorFacade.isNativePlatform();
    },
  },
  methods: {
    async navigateToGuidanceCalculator() {
      await this.$router.push({ name: RouteNames.GUIDANCE_CALCULATOR, params: { contractId: -1 } });
    },
  },
};

export default defineComponent(componentOptions);
</script>
